/* eslint-disable no-undef */

import * as api from "../../redux/api/actions.js";
import { loadGigyaScript } from "../../utils/gigyaLoader.js";

import React, { Component } from "react";

import { AVAILABLE_ENTITIES } from "../../database";
import Box from "@mui/material/Box";
import Prompt from "../../components/Prompt.js";
import TitleBar from "../../components/TitleBar";
import FormSection from "../../components/forms/FormSection";
import _ from "lodash";
import { connect } from "react-redux";
import { getLoggedUser, logout } from "../../redux/auth/actions";
import { utils } from "../../database";
import { withRouter } from "../../utils/withRouterCompat"
;

class RegisterGigya extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;

    // Verificar se é primeiro login
    const isFirstLogin = props.location?.state?.isFirstLogin || false;

    this.state = {
      isFirstLogin,
      submitCount: 0,
    };
  }

  // Funções removidas: onSubmit e initSync
  // Não criamos mais o usuário imediatamente após registro no Gigya
  // O Gigya enviará o email de reset de senha usando o onAfterSubmit deles
  // O usuário será criado no backend no primeiro login através do LoginGigya.js

  onGigyaServiceReady() {
    if (this.state.isFirstLogin) {
      // Configuração simplificada para primeiro login
      this.renderFirstLoginForm();
    } else {
      // Configuração normal para usuários já registrados
      this.renderNormalForm();
    }
  }

  renderFirstLoginForm() {
    gigya.accounts.showScreenSet({
      screenSet: "RegistrationLogin_prospect",
      startScreen: "gigya-register-screen",
      containerID: "container",
      lang: "pt",
      // Usamos onBeforeSubmit em vez de onAfterSubmit para não bloquear o email
      onBeforeSubmit: (eventObj) => {
        // Incrementa contador de submits
        const newCount = this.state.submitCount + 1;
        this.setState({ submitCount: newCount });

        // Primeiro submit: dados da conta (aguarda código)
        // Segundo submit: código verificado ✅ REDIRECIONA!
        if (newCount >= 2) {
          setTimeout(() => {
            // Redireciona para login após conclusão do fluxo
            // Aguarda 3 segundos para Gigya processar tudo (incluindo email)
            this.props.history.push("/login");
          }, 3000);
        }
      },
      onError: (eventObj) => {
        console.error("❌ Erro no registro Gigya:", eventObj);
      },
    });
  }

  renderNormalForm() {
    gigya.accounts.showScreenSet({
      screenSet: "RegistrationLogin_prospect",
      startScreen: "gigya-register-screen",
      lang: "pt",
      containerID: "container",
      // Usamos onBeforeSubmit em vez de onAfterSubmit para não bloquear o email
      onBeforeSubmit: (eventObj) => {
        // Incrementa contador de submits
        const newCount = this.state.submitCount + 1;
        this.setState({ submitCount: newCount });

        // Primeiro submit: dados da conta (aguarda código)
        // Segundo submit: código verificado ✅ REDIRECIONA!
        if (newCount >= 2) {
          setTimeout(() => {
            // Redireciona para lista de usuários após conclusão
            // Aguarda 3 segundos para Gigya processar tudo (incluindo email)
            this.props.history.push("/users");
          }, 3000);
        }
      },
      onError: (eventObj) => {
        console.error("❌ Erro no registro Gigya:", eventObj);
      },
    });
  }

  async componentDidMount() {
    // Se for primeiro login, faz logout da sessão temporária para evitar cache indesejado
    if (this.state.isFirstLogin) {
      this.props.logout();
    } else {
      // Só buscar roles se não for primeiro login
      this.props.getAvailableRoles();
    }
    this._isMounted = true;
    try {
      // Carrega o script do Gigya com a chave de registro
      await loadGigyaScript(process.env.REACT_APP_REGISTER_GIGYA_API_KEY);
      // Verifica se o componente ainda está montado antes de continuar
      if (this._isMounted) {
        this.onGigyaServiceReady();
      }
    } catch (error) {
      console.error("Erro ao carregar Gigya:", error);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const embedded = this.props.embedded === true;

    const gigyaContent = (
      <>
        {/* Só mostra TitleBar se NÃO for primeiro login e NÃO for embedded (para evitar navegação indesejada) */}
        {!this.state.isFirstLogin && !embedded && (
          <TitleBar
            title="Registro"
            paths={[
              {
                label: "Registro",
              },
            ]}
          />
        )}
        <Box sx={{ mt: embedded ? 0 : 1 }}>
          {/*
            display: 'block' em vez de 'inline-flex'.
            inline-flex constrangia o #container ao tamanho do conteúdo, e
            combinado com FormSection maxWidth estreito o widget do Gigya
            ficava "encolhido". block + width 100% deixa o screen-set
            renderizar no espaço completo do container.
          */}
          <div
            id="container"
            style={{
              display: "block",
              width: "100%",
            }}
          />
        </Box>
      </>
    );

    if (embedded) {
      // Renderização dentro de outro container (Users/Create) — strip o outer
      // Box(100vh) + FormSection card. Renderiza só o widget.
      return gigyaContent;
    }

    // Standalone (route /register-gigya, /primeiro-login).
    //
    // Layout decisions (2026-05-11, fix #register-gigya cortado):
    //
    // 1. alignItems: 'flex-start' (não center) — center clipava o topo quando
    //    o form Gigya era mais alto que a viewport. flex-start permite scroll.
    // 2. py: { xs: 2, md: 4 } — respiração vertical sem depender de
    //    centralização precisa.
    // 3. FormSection com maxWidth 960 — default 720 era estreito pro screen-set
    //    completo do Gigya (registration + telefone + verificação).
    // 4. Sem description — economiza vertical space; Gigya screen-set tem seu
    //    próprio header.
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'center',
          bgcolor: 'background.default',
          px: 2,
          py: { xs: 2, md: 4 },
        }}
      >
        <FormSection
          variant="card"
          maxWidth={960}
          title={!this.state.isFirstLogin ? "Registro" : undefined}
        >
          {gigyaContent}
        </FormSection>
      </Box>
    );
  }
}

const propsFromDatabase = async (props) => {
  // Se for primeiro login, não precisa buscar dados completos do usuário
  const isFirstLogin = props.location?.state?.isFirstLogin || false;

  if (isFirstLogin) {
    return {
      user: null,
      isAdministrator: false,
    };
  }

  try {
    const loggedUser = await getLoggedUser();
    if (!loggedUser || !loggedUser.userId) {
      return {
        user: null,
        isAdministrator: false,
      };
    }

    const user = await utils.getElement(
      AVAILABLE_ENTITIES.USERS,
      loggedUser.userId,
    );
    const isAdministrator = _.find(
      loggedUser.roles,
      (el) => el === "Administrador",
    );

    return {
      user,
      isAdministrator,
    };
  } catch (error) {
    console.warn("Error fetching user data:", error);
    return {
      user: null,
      isAdministrator: false,
    };
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    getAvailableRoles: () => api.get(dispatch, "users", `Profile/`),
  };
};

const mapStateToProps = (state) => ({
  loading: api.getApiLoading(state, `Profile/`),
  availableRoles: api.getApiResult(state, `Profile/`) || [],
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(utils.withPropsFromDatabase(propsFromDatabase, withRouter(RegisterGigya)));
